<!--
  Compact header indicator shown while impersonating (ADO #5066). Replaces the old
  full-width banner: states impersonation is active, counts down the remaining TTL, and
  the trailing x stops the session. Sits left of the DEV badge in the app header.
-->
<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useImpersonationSession } from "@/composables/useImpersonationSession";

const { remaining, stopping, stopImpersonation } = useImpersonationSession();
</script>

<template>
  <div
    role="status"
    class="flex items-center gap-2 rounded-lg bg-(--ecx-danger) py-1 ps-3 pe-1 text-sm font-medium text-(--ecx-danger-foreground)"
  >
    <span class="whitespace-nowrap">
      Impersonation is on!<template v-if="remaining"> Ends in: {{ remaining }}</template>
    </span>
    <button
      type="button"
      class="inline-flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full hover:bg-white/15 disabled:cursor-not-allowed disabled:opacity-60"
      aria-label="Stop impersonating"
      title="Stop impersonating"
      :disabled="stopping"
      @click="stopImpersonation"
    >
      <FontAwesomeIcon :icon="faXmark" />
    </button>
  </div>
</template>
